import React, {useState, useEffect} from 'react'
import {useDispatch} from 'react-redux'
import useTitle from '../../../hooks/useTitle'
import {setTitle} from '../../../actions/'
import Filters from './Filters'
import Table from './Table'
import withPagination from '../../withPagination'
import useEntities from '../../../hooks/useEntities'

const TablePaginated = withPagination(Filters, Table)


const TicketSources = () => {
  const dispatch = useDispatch()

  useTitle((title) => dispatch(setTitle(title)), 'Ticket - sorgenti')

  const {entities, total} = useEntities('ticket-sources', {isNotPaginated: true})
  const [shownEntities, setShownEntities] = useState([])

  useEffect(() => {
    setShownEntities(entities)
  }, [entities])

  return (
    <TablePaginated
      entities={entities}
      shownEntities={shownEntities}
      total={total}
      isLocal
      setShownEntities={setShownEntities}
    />
  )
}

export default TicketSources